<template>

    <div :class="whatWrapper">
        <a @click="showHidePop()">
            <i
                    class=" abtgpopover-icon" :class="whatIcon" :style="{color: getColor}"></i></a>
        <div class="abtgpopover" :style="{display: showPopup, left: getPosition, top:getTopPosition }">
            <div class="abtgpopover-arrow" :style="{left: getArrowPosition}" v-if="position != 'top' "></div>
            <div class="abtgpopover-content">
                <div style="border-bottom:1px solid #ccc; display:flex;width:100%; ">
                    <div class="abtgpopover-title">{{$t(getTitle)}}</div>
                </div>
            </div>
            <div class="abtgpopover-content abtgpopover-topair">
                <div class="abtgpopover-text">
                    <span v-html="$t(getContent)"></span>
                    <p class="text-right">
                        <a class="mdl-button mdl-js-button mdl-button--icon abtgpopover-closebutton"
                           @click="showHidePop()">
                            <i class="fas fa-times abtg__fontIcon"></i>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {mixin} from '@/helpers/helper'
    import {Money} from 'v-money';

    export default {
        mixins: [mixin],
        props: ['module', 'content', 'position', 'color', 'iconType'],
        components: {Money},
        data: function () {
            return {
                showPopup: 'none',
            }
        },

        computed: {

            whatIcon: function()
            {
                if(this.iconType === 'simple')
                {
                    return 'fas fa-question-circle';
                }
                return 'fas fa-info-circle';
            },
            whatWrapper: function()
            {
                if(this.iconType === 'simple')
                {
                    return 'abtgpopover-simpleWrapper';
                }
                return 'abtgpopover-wrapper';
            },
            getTitle: function()
            {
                return this.module+ '.popover_' + this.content + '_title' ;
            },
            getContent: function()
            {
                return this.module + '.popover_' + this.content + '_content';
            },

            getPosition: function()
            {
                if(this.position === 'left')
                {
                    return '-320px !important';
                }

                if(this.position === 'top')
                {
                    return '-160px !important';
                }

            },

            getTopPosition: function()
            {
                if(this.position === 'top')
                {
                    return '-420px !important';
                }
            },

            getArrowPosition: function()
            {
                if(this.position === 'left')
                {
                    return '320px !important';
                }
            },

            getColor: function()
            {
                if(this.color != undefined)
                {
                    return this.color;
                }

                return '';
            }


        },
        created: function () {
        },
        watch:{
            showPopup(showPopup)
            {
                if(showPopup === 'block'){
                    document.addEventListener('click', this.closeIfClickedOutSide);
                }
            }
        },
        methods: {
            showHidePop: function()
            {
                this.showPopup = this.showPopup == 'none' ? 'block' : 'none';
            },

            closeIfClickedOutSide(event)
            {
                let cl = '.' + this.whatWrapper;
                if( ! event.target.closest(cl)){
                    this.showPopup = 'none';
                }
            }
        }
    }
</script>
